import { render, staticRenderFns } from "./StockProductRequests.vue?vue&type=template&id=65e4ef4d&"
import script from "./StockProductRequests.vue?vue&type=script&lang=js&"
export * from "./StockProductRequests.vue?vue&type=script&lang=js&"
import style0 from "./StockProductRequests.vue?vue&type=style&index=0&id=65e4ef4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports